import React from "react";
import Accordion from "react-bootstrap/Accordion";

const Join = () => {
  return (
    <div className="Introducing  ">
      <div className="faqs  ">
        <h2 className="text-center">
          {" "}
          <span>Join the Community</span>
        </h2>
        {/* <div className="text-center">
          <div className="line mb-3"></div>
        </div> */}
        <p className="text-center mb-5 p2">
          Thousands of backers, creators, and validators <br />
          shaping decentralized crowdfunding.
        </p>
        <div className="container">
          <div className="row ">
            <div className="col-lg-4">

            </div>
            <div
              className="col-lg-4 mb-5 mb-lg-0"
            
            >
              <div className="custom-input d-flex align-items-center justify-content-between">
                <input type="text" placeholder="name@email.com" />{" "}
                <button className="btn-green">Join</button>
              </div>
            </div>
            <div className="col-lg-4">
                
                </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Join;
